exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".icon {\n  width: 25px;\n  height: 22px;\n  display: inline-block;\n  margin-right: 10px; }\n  @media screen and (min-width: 1025px) {\n    .icon {\n      width: 30px; } }\n\n.left-bar-control a.selected {\n  background-color: rgba(106, 174, 32, 0.1); }\n", ""]);

